import {remoteRoutingModule} from "./remoteRoutingModule";

export interface RemoteRoutingUrls {
    "orchestrator.get-mapped-machine-types": string
    "orchestrator.remote-type-configuration": string
    "orchestrator.create-remote-type-configuration": string
    "orchestrator.update-type-configuration": string
    "orchestrator.test-routing-parallelism": string
    "orchestrator.get-routing-availability": string
}

export class RemoteRoutingUrlsProvider {
    private urls: RemoteRoutingUrls

    setUrls(urls: RemoteRoutingUrls) {
        this.urls = urls;
    }

    $get()  {
        return this.urls
    }
}

remoteRoutingModule.provider("remoteRoutingUrls", RemoteRoutingUrlsProvider)